import Chart from 'chart.js/auto'
import {
  colors,
  lineChartOptions,
  barChartOptions,
  doughnutChartOptions,
  formatDateLabel,
  reduceLabels
} from './chart_config'

// Views over time - line chart
export function buildArticleViewsChart(canvas, data) {
  const formattedLabels = reduceLabels(data.labels)

  return new Chart(canvas, {
    type: 'line',
    data: {
      labels: formattedLabels.length ? formattedLabels : data.labels.map(formatDateLabel),
      datasets: [{
        label: 'Views',
        data: data.data,
        borderColor: colors.neutral[900],
        backgroundColor: colors.neutralAlpha[20],
        fill: true
      }]
    },
    options: {
      ...lineChartOptions,
      plugins: {
        ...lineChartOptions.plugins,
        tooltip: {
          ...lineChartOptions.plugins.tooltip,
          callbacks: {
            title: (items) => {
              const idx = items[0].dataIndex
              return formatDateLabel(data.labels[idx])
            },
            label: (item) => `${item.raw.toLocaleString()} view${item.raw !== 1 ? 's' : ''}`
          }
        }
      }
    }
  })
}

// Device breakdown - doughnut chart
export function buildDeviceBreakdownChart(canvas, data) {
  return new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: data.labels,
      datasets: [{
        data: data.data,
        backgroundColor: [
          colors.chart[0], // Desktop - darkest
          colors.chart[1], // Mobile
          colors.chart[2] // Tablet - lightest
        ],
        borderWidth: 2,
        borderColor: colors.neutral.white
      }]
    },
    options: {
      ...doughnutChartOptions,
      plugins: {
        ...doughnutChartOptions.plugins,
        tooltip: {
          ...doughnutChartOptions.plugins.tooltip,
          callbacks: {
            label: (item) => {
              const total = item.dataset.data.reduce((a, b) => a + b, 0)
              const percentage = total > 0 ? ((item.raw / total) * 100).toFixed(1) : 0
              return `${item.label}: ${item.raw.toLocaleString()} (${percentage}%)`
            }
          }
        }
      }
    }
  })
}

// Bot vs Human - doughnut chart
export function buildBotVsHumanChart(canvas, data) {
  return new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: data.labels,
      datasets: [{
        data: data.data,
        backgroundColor: [
          colors.chart[0], // Human - dark
          colors.chart[3] // Bot - light
        ],
        borderWidth: 2,
        borderColor: colors.neutral.white
      }]
    },
    options: {
      ...doughnutChartOptions,
      plugins: {
        ...doughnutChartOptions.plugins,
        tooltip: {
          ...doughnutChartOptions.plugins.tooltip,
          callbacks: {
            label: (item) => {
              const total = item.dataset.data.reduce((a, b) => a + b, 0)
              const percentage = total > 0 ? ((item.raw / total) * 100).toFixed(1) : 0
              return `${item.label}: ${item.raw.toLocaleString()} (${percentage}%)`
            }
          }
        }
      }
    }
  })
}

// Bot type breakdown - doughnut chart
export function buildBotTypeChart(canvas, data) {
  return new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: data.labels,
      datasets: [{
        data: data.data,
        backgroundColor: [
          colors.chart[0], // LLM Crawlers
          colors.chart[1], // Search Crawlers
          colors.chart[2] // Other Bots
        ],
        borderWidth: 2,
        borderColor: colors.neutral.white
      }]
    },
    options: {
      ...doughnutChartOptions,
      plugins: {
        ...doughnutChartOptions.plugins,
        tooltip: {
          ...doughnutChartOptions.plugins.tooltip,
          callbacks: {
            label: (item) => {
              const total = item.dataset.data.reduce((a, b) => a + b, 0)
              const percentage = total > 0 ? ((item.raw / total) * 100).toFixed(1) : 0
              return `${item.label}: ${item.raw.toLocaleString()} (${percentage}%)`
            }
          }
        }
      }
    }
  })
}

// Referrer sources - horizontal bar chart
export function buildReferrerSourcesChart(canvas, data) {
  return new Chart(canvas, {
    type: 'bar',
    data: {
      labels: data.labels,
      datasets: [{
        label: 'Views',
        data: data.data,
        backgroundColor: colors.chart[0],
        borderColor: colors.neutral[900],
        borderWidth: 2
      }]
    },
    options: {
      ...barChartOptions,
      indexAxis: 'y',
      plugins: {
        ...barChartOptions.plugins,
        tooltip: {
          ...barChartOptions.plugins.tooltip,
          callbacks: {
            label: (item) => `${item.raw.toLocaleString()} view${item.raw !== 1 ? 's' : ''}`
          }
        }
      },
      scales: {
        x: {
          ...barChartOptions.scales.x,
          beginAtZero: true
        },
        y: {
          ...barChartOptions.scales.y,
          grid: { display: false }
        }
      }
    }
  })
}
